import { z } from "zod";
import { timestampsSchema } from "./common";

export const cfImagesStatusSchema = z.enum(["pending", "ready", "failed", "skipped"]);
export type CfImagesStatus = z.infer<typeof cfImagesStatusSchema>;

export const mediaDtoSchema = z
  .object({
    id: z.string().uuid(),
    modelType: z.string(),
    modelId: z.string().uuid().nullable(),
    collectionName: z.string(),
    name: z.string(),
    fileName: z.string(),
    mimeType: z.string().nullable(),
    size: z.number().int().nonnegative(),
    spacesKey: z.string(),
    spacesUrl: z.url(),
    cfImageId: z.string().nullable(),
    cfImageVariants: z.array(z.url()).nullable(),
    cfImagesStatus: cfImagesStatusSchema,
    orderColumn: z.number().int().nullable(),
  })
  .extend(timestampsSchema.shape);
export type MediaDTO = z.infer<typeof mediaDtoSchema>;

export const presignRequestSchema = z.object({
  modelType: z.string().min(1),
  modelId: z.string().uuid().optional(),
  collectionName: z.string().min(1),
  fileName: z.string().min(1).max(256),
  mimeType: z.string().min(1),
  size: z.number().int().positive(),
});
export type PresignRequest = z.infer<typeof presignRequestSchema>;

export const presignResponseSchema = z.object({
  url: z.url(),
  method: z.literal("PUT"),
  headers: z.record(z.string(), z.string()),
  key: z.string(),
  /** Public CDN URL the file will be reachable at after a successful PUT. */
  publicUrl: z.url(),
});
export type PresignResponse = z.infer<typeof presignResponseSchema>;

export const createMediaSchema = z.object({
  modelType: z.string().min(1),
  modelId: z.string().uuid(),
  collectionName: z.string().min(1),
  name: z.string().min(1),
  fileName: z.string().min(1),
  mimeType: z.string().min(1),
  size: z.number().int().positive(),
  key: z.string().min(1),
  extraCustomProps: z.record(z.string(), z.unknown()).optional(),
});
export type CreateMediaInput = z.infer<typeof createMediaSchema>;
